import { Trans, t } from "@lingui/macro";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import moment from "moment";
import { todayYesterday } from "../../../utils/time";
import { unassociateEquipRule } from "../../../redux/modules/_BETA/unassociate";
import { i18n } from "../../../i18n";
import {
  Wrapper,
  Inner,
  Content,
  Row,
  QuickLink,
  PreviewHeader,
  UnassociateButton,
} from "./Preview.styles";

interface DispatchProps {
  unassociateEquip(id: any, name: any): () => void;
}

interface OwnProps {
  data?: Insite.API.ActionEquip;
  onChange?(): void;
}

type Props = OwnProps & DispatchProps;

const Preview: React.FunctionComponent<Props> = ({
  data,
  unassociateEquip,
}) => (
  <Wrapper>
    <Inner>
      {data && (
        <Fragment>
          <PreviewHeader>
            <h3>
              <Trans id="equip_preview.hit_details">Hit Details</Trans>
            </h3>
            <UnassociateButton
              onClick={unassociateEquip(data.id, data.targetName)}
            >
              <Trans id="equip_preview.unassociate">unassociate</Trans>
            </UnassociateButton>
          </PreviewHeader>
          <Content>
            <Row>
              <strong>
                <Trans id="equip_preview.equip_label">Equip:</Trans>
              </strong>{" "}
              {data.targetName}
            </Row>
            <Row>
              <strong>
                <Trans id="equip_preview.rule_label">Rule:</Trans>
              </strong>{" "}
              {data.ruleName}
            </Row>
            <Row>
              <strong>
                <Trans id="equip_preview.severity_label">Severity:</Trans>
              </strong>{" "}
              {data.severity}
            </Row>
            <Row>
              <strong>
                <Trans id="equip_preview.latest_hit_label">Latest Hit:</Trans>
              </strong>{" "}
              {todayYesterday(moment(data.occurredOn))}
            </Row>
            <Row>
              <strong>
                <Trans id="equip_preview.duration_label">Duration:</Trans>
              </strong>{" "}
              {data.times}
            </Row>
            <Row>
              <strong>
                <Trans id="equip_preview.description_label">Description:</Trans>
                <br />
              </strong>
              {data.description}
            </Row>
          </Content>
          <QuickLink>
            <a href={data.reportUrl} target="_blank" rel="noopener">
              <Trans id="equip_preview.view_trend_graph">
                View trend graph
              </Trans>
            </a>
          </QuickLink>
        </Fragment>
      )}
    </Inner>
  </Wrapper>
);

Preview.propTypes = {
  unassociateEquip: PropTypes.func.isRequired,
};

Preview.defaultProps = {
  data: undefined,
};

function confirmUnassociate(equipName: string) {
  return window.confirm(
    i18n._(
      t(
        "equip_preview.confirm_unassociate"
      )`You are about to unassociate ${equipName} from this action, continue?`
    )
  );
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: OwnProps
): DispatchProps {
  return {
    unassociateEquip: (syncoId, equipName) => () => {
      if (confirmUnassociate(equipName)) {
        dispatch(unassociateEquipRule({ equipRuleIds: [syncoId] }));
        if (typeof ownProps.onChange === "function") ownProps.onChange();
      }
    },
  };
}

export default connect(undefined, mapDispatchToProps)(Preview);
